import { render, staticRenderFns } from "./AlarmRelatedInfo.vue?vue&type=template&id=31012566&scoped=true&"
import script from "./AlarmRelatedInfo.vue?vue&type=script&lang=js&"
export * from "./AlarmRelatedInfo.vue?vue&type=script&lang=js&"
import style0 from "./AlarmRelatedInfo.vue?vue&type=style&index=0&id=31012566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31012566",
  null
  
)

export default component.exports